import Api from './api';

const bidsListRequest = (query) => {
    const access_token = JSON.parse(localStorage.getItem("jwt"))
    return Api().get('/api/bids', {
        headers: { Authorization: 'Bearer ' + access_token } ,
        params: query
    })
}

const bidRequest = (bidId) => {
    const access_token = JSON.parse(localStorage.getItem("jwt"))
    return Api().get('/api/bid/' + bidId, {
        headers: { Authorization: 'Bearer ' + access_token } ,
    })
}


const updateBidRequest = async (bid) => {
    const access_token = JSON.parse(localStorage.getItem("jwt"))
    return Api().put('/api/bids/' + bid.id , bid, { headers: { Authorization: 'Bearer ' + access_token } })
}

const placeBidRequest = (data) => {
    const access_token = JSON.parse(localStorage.getItem("jwt"))
    return Api().post('/api/bids/', data, { headers: { Authorization: 'Bearer ' + access_token } })
}

const updateBidGroupRequest = (group) => {
    const access_token = JSON.parse(localStorage.getItem("jwt"))
    return Api().put('/api/groups/' + group.id , group, { headers: { Authorization: 'Bearer ' + access_token } })
}

const changeBidGroupRequest = (group) => {
    const access_token = JSON.parse(localStorage.getItem("jwt"))
    return Api().post('/api/groups/', group, { headers: { Authorization: 'Bearer ' + access_token } })
}


export default { bidsListRequest, updateBidRequest, placeBidRequest, updateBidGroupRequest, changeBidGroupRequest, bidRequest}



// WEBPACK FOOTER //
// ./src/api/apiBids.js